module.exports = __webpack_public_path__ + "static/media/button-green.91f1f10b.png";